import { render, staticRenderFns } from "./DictionaryTerm.vue?vue&type=template&id=cb70857a&"
import script from "./DictionaryTerm.vue?vue&type=script&lang=js&"
export * from "./DictionaryTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports